import Splide from '@splidejs/splide';
import { Fancybox } from "@fancyapps/ui";

/* ==========================================================================
   Sub nav toggle
   ========================================================================== */

const subNavItems = document.querySelectorAll('.js-toggle-subnav');

if (subNavItems) {
    subNavItems.forEach((subnav) => {
        subnav.addEventListener('click', (e) => toggleAccordion(e));
    });
}

const toggleAccordion = (e) => {
    const targetLink = e.currentTarget;
    const parentLi = targetLink.closest('li');
    const subNav = parentLi?.querySelector('.sub-nav');

    if (!subNav) {
        return;
    }

    const chevronClicked = e.target.closest('.sub-nav-icon');
    const iconClicked = e.target.closest(
        '.sub-nav-icon-plus, .sub-nav-icon-minus'
    );
    const isTopNode = targetLink.classList.contains('top-node');

    if (chevronClicked || iconClicked || isTopNode) {
        e.preventDefault();

        const isExpanded = targetLink.classList.contains('sub-nav--expand');

        if (isExpanded) {
            targetLink.classList.remove('is-active', 'sub-nav--expand');
        } else {
            targetLink.classList.add('is-active', 'sub-nav--expand');
        }

        document
            .querySelector('.b-uikit-menu')
            ?.classList.remove('is-shrunk');

        return;
    }
};


/* ==========================================================================
   Mobile Menu Toggle
   ========================================================================== */

function toggleMenu() {
    document.getElementById("main-menu").classList.toggle("is-active");
}
window.toggleMenu = toggleMenu;

/* ==========================================================================
   Shrink Menu Toggle
   ========================================================================== */

function shrinkMenu() {
    document.getElementById("main-menu").classList.toggle("is-shrunk");
}
window.shrinkMenu = shrinkMenu;

/* ==========================================================================
   Modal Toggle
   ========================================================================== */

function openModal(el) {
    var targetModal = el.getAttribute('aria-controls');
    document.getElementById(targetModal).classList.add("is-active");
}
window.openModal = openModal;

function closeModal(el) {
    el.closest(".b-uikit-modal").classList.remove("is-active");
}
window.closeModal = closeModal;

/* ==========================================================================
   Button Menu Toggle
   ========================================================================== */

document.querySelectorAll('.js-toggle-button-menu').forEach(function (e, i) {
    e.addEventListener('click', function (event) {
        event.preventDefault();
        this.classList.toggle("is-active");
        this.nextElementSibling.classList.toggle("is-active");
        document.querySelectorAll('.js-toggle-button-menu').forEach((e) => {
            if (e !== this) {
                e.classList.remove("is-active");
                e.nextElementSibling.classList.remove("is-active");
            }
        });
    });
});

document.addEventListener('click', e => {
    if (!e.target.closest('.b-uikit-button-menu')) {
        document.querySelectorAll('.js-toggle-button-menu').forEach((e) => {
            e.classList.remove("is-active");
        });
        document.querySelectorAll('.b-uikit-button-menu__popout').forEach((e) => {
            e.classList.remove("is-active");
        });
    }
});

/* ==========================================================================
   Sliders
   ========================================================================== */

function SlideCounterExtension(Splide, Components) {
    const { track } = Components.Elements;

    let elm;
    let splideIndex;
    let splideIndexPad, splideLengthPad;
    let splideLength

    function mount() {
        elm = document.createElement('div');
        elm.classList.add('splide__counter');

        track.parentElement.insertBefore(elm, track.nextSibling);

        update();
        Splide.on('move', update);
    }

    function update() {
        // Add leading zero to the numbers
        splideIndex = Splide.index + 1;
        splideIndexPad = splideIndex.toString().padStart(2, '0')
        splideLength = Splide.length;
        splideLengthPad = splideLength.toString().padStart(2, '0')
        elm.textContent = `${splideIndexPad} — ${splideLengthPad}`;
    }

    return {
        mount,
    };
}

var imageSlider = document.querySelectorAll('.js-image-slider');
if (imageSlider.length) {
    for (var i = 0; i < imageSlider.length; i++) {
        var splideElement = imageSlider[i];
        var splideDefaultOptions = {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            arrows: true,
            pagination: false,
            gap: '24px',
            lazyLoad: 'nearby',
            arrowPath: 'M39.8,19.6l-4.2-4.2c-.3-.3-.7-.3-.9,0-.3.3-.3.7,0,.9l3,3H0v1.3h37.7l-3,3c-.3.3-.3.7,0,.9s.7.3.9,0l4.2-4.2c.3-.3.3-.7,0-.9h0Z',
            breakpoints: {
                768: {
                    perPage: 2
                },
                740: {
                    perPage: 1
                },
            },
        }
        var splide = new Splide(splideElement, splideDefaultOptions);
        splide.mount({
            SlideCounterExtension
        });
    }
}

/* ==========================================================================
   Restore active menu state on page load
   ========================================================================== */

window.addEventListener('DOMContentLoaded', () => {
    const currentPath = window.location.pathname;
    const currentFullPath = window.location.pathname + window.location.search;

    let activeLink = document.querySelector(`a[href="${currentFullPath}"]`);

    if (!activeLink) {
        activeLink = document.querySelector(`a[href="${currentPath}"]`);
    }

    if (!activeLink) {
        const allLinks = document.querySelectorAll('.js-toggle-subnav');

        allLinks.forEach((link, index) => {
            const linkHref = link.getAttribute('href');
            const linkTitle = link.getAttribute('title');

            if (linkHref && linkHref === currentFullPath) {
                activeLink = link;
            }
        });
    }

    if (activeLink) {
        activeLink.classList.add('is-active', 'sub-nav--expand');

        let parentItem = activeLink.closest('.b-uikit-menu__item');
        let level = 0;

        while (parentItem) {
            const parentToggle = parentItem.querySelector(':scope > .js-toggle-subnav');

            if (parentToggle) {
                parentToggle.classList.add('is-active', 'sub-nav--expand');
            }
            parentItem = parentItem.parentElement.closest('.b-uikit-menu__item');
            level++;
        }
    } else {
        console.log('No active link found - menu will not expand');
    }
    const topNode = document.querySelector('.top-node');

    if (topNode && activeLink) {
        const topNodeParentLi = topNode.closest('li');
        const activeLinkIsInsideTopNode = topNodeParentLi && topNodeParentLi.contains(activeLink);
        if (activeLinkIsInsideTopNode) {
            topNode.classList.add('is-active', 'sub-nav--expand');
        }
    }
    // Attach mobile menu toggle handlers to any menu toggle buttons
    document.querySelectorAll('.b-uikit-menu__menu-toggle').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            toggleMenu();
        });
    });
});

/* ==========================================================================
   Fancybox Lightbox
   ========================================================================== */

Fancybox.bind('[data-fancybox]', {
  Html: {
    youtube: {
      controls: 0,
      rel: 0,
      fs: 0
    }
  }
});

/* ==========================================================================
   Read more/less toggle
   ========================================================================== */

function hasMoreThanNLines(element, lines) {
  const style = window.getComputedStyle(element);
  const lineHeight = parseFloat(style.lineHeight);

  // Fallback if line-height is "normal"
  const effectiveLineHeight = isNaN(lineHeight)
    ? parseFloat(style.fontSize) * 1.2
    : lineHeight;

  return element.scrollHeight > effectiveLineHeight * lines;
}

function setupReadMore(wrapper) {
  const content = wrapper.querySelector('.read-more-wrapper__content');
  const button = wrapper.querySelector('.read-more-button');

  if (!content || !button) return;

  // Detect overflow
  if (!hasMoreThanNLines(content, 3)) {
    button.hidden = true;
    return;
  }

  button.hidden = false;
  button.textContent = 'Read More';
  button.setAttribute('aria-expanded', 'false');

  button.addEventListener('click', () => {
    const isOpen = content.classList.toggle('open');
    button.classList.toggle('active');

    button.textContent = isOpen ? 'Read Less' : 'Read More';
    button.setAttribute('aria-expanded', String(isOpen));
  });
}

// Initialize all instances
document.querySelectorAll('.read-more-wrapper').forEach(setupReadMore);

// Re-check on resize
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.querySelectorAll('.read-more-wrapper').forEach(wrapper => {
      const button = wrapper.querySelector('.read-more-button');
      if (button) button.hidden = false; // reset
      setupReadMore(wrapper);
    });
  }, 150);
});
